import React, {useEffect, useRef, useState} from "react";

import "./JackpotLeavleList.scss";
import Odometer from "odometer";
import {t} from "i18next";

const JackpotLeavleList = () => {
  const [jackpools] = useState([
    {
      title: t("jackpot.Hearts"),
      amount: 15040.71,
      ref: useRef(null),
      odometer: null,
      listItems: [
        {
          time: '17.04.2023, 20:34',
          amount: '46,013.29',
          title: t("jackpot.LargestWinner"),
          id: '',
        },
        {
          time: '30.04.2023, 05:19',
          amount: '25,882.23',
          title: t("jackpot.LastWinner"),
          id: '',
        },
        {
          amount: '156',
          title: t("jackpot.NumberOfWinners"),
        },
      ]
    },
    {
      title: t("jackpot.Diamonds"),
      amount: 15040.71,
      ref: useRef(null),
      odometer: null,
      listItems: [
        {
          time: '17.04.2023, 20:34',
          amount: '46,013.29',
          title: t("jackpot.LargestWinner"),
          id: '',
        },
        {
          time: '30.04.2023, 05:19',
          amount: '25,882.23',
          title: t("jackpot.LastWinner"),
          id: '',
        },
        {
          amount: '156',
          title: t("jackpot.NumberOfWinners"),
        },
      ]
    },
    {
      title: t("jackpot.Clubs"),
      amount: 15040.71,
      ref: useRef(null),
      odometer: null,
      listItems: [
        {
          time: '17.04.2023, 20:34',
          amount: '46,013.29',
          title: t("jackpot.LargestWinner"),
          id: '',
        },
        {
          time: '30.04.2023, 05:19',
          amount: '25,882.23',
          title: t("jackpot.LastWinner"),
          id: '',
        },
        {
          amount: '156',
          title: t("jackpot.NumberOfWinners"),
        },
      ]
    },
  ]);

  useEffect(() => {
    jackpools.forEach((item) => {
      item.odometer = new Odometer({
        el: item.ref.current,
        value: item.amount,   // initial value
        format: "(,ddd).dd",
        theme: "default"
      });
    })
  }, [])

  useEffect(() => {
    const timersR: NodeJS.Timer[] = [];
    jackpools.forEach((item, index) => {
      timersR.push(
          setInterval(() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            item.odometer.update(item.amount + Math.floor(Math.random() * (55 - 15 + 1) + 15))
          }, 5000)
      );
    })

    // clearing interval
    return () => timersR.forEach((timer) => clearInterval(timer));
  }, [])

  return (
    <ul className="casinoJackpotLevelList-bc">
      {
        jackpools.map(function(item, index){
          return <li key={index} className="casinoJackpotLevelEl-bc">
            <h3 className="casinoJackpotLevelTitle-bc">{item.title}</h3>
            <div ref={item.ref} id="odometer" className="odometer casinoJackpotLevelPrice-bc odometer-auto-theme" data-cur="₺"></div>
          </li>
          })
      }

    </ul>
  );
};

export { JackpotLeavleList };
